export default "__VITE_ASSET__b8c69cb2__"